import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import { resetConnection } from "../../store/actions/connection";
import { withRouter } from "react-router-dom";
import { Input } from 'semantic-ui-react'
import { mobileMatchMedia } from '../../util';
import { setAvailabilityModal } from "../../store/actions/app";
import { setAutofocus } from "../../store/actions/connection";


class FibreReadyFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: ""
    };
    this.resetError = this.resetError.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  resetError() {
    if (this.state.error) {
      this.setState({ error: null });
    }
  }
  openModal(e) {
    this.props.setAutofocus(true);
    setTimeout(() => {
      this.props.history.push('/check');
    })
  }


  render() {
    const { error } = this.state;
    const addressPlaceholderText = (mobileMatchMedia()) ? 'Start typing your address...' : 'Start typing your building address';
    return (
      <div className="ui two column grid sm-justify-center fibreready-footer">
        <div className="sixteen wide tablet six wide computer eight wide large column left floated sm-text-center">
          <h2 className="footer__form-title">Get FibreStream Today</h2>
        </div>
        <div className="sixteen wide tablet ten wide computer eight wide large column form-xs right aligned sm-text-center">
          <form
            className="ui form grid check-address hero inverted-form home-form"
            onSubmit={e => e.preventDefault()}
          >
            <div
              className={classNames("field ml-auto pr-0", {
                "is-error": error
              })}
              onClick={this.openModal}
            >
              <Input
                disabled
                type="text"
                placeholder={addressPlaceholderText}
              />
            </div>
          </form>
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    address: state.connection.address
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetConnection: () => dispatch(resetConnection()),
    setAvailabilityModal: (flag) => dispatch(setAvailabilityModal(flag)),
    setAutofocus: (flag) => dispatch(setAutofocus(flag)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(FibreReadyFooter)
);



// WEBPACK FOOTER //
// ./src/components/footer/FibreReadyFooter.js